import { createFileRoute, notFound } from "@tanstack/react-router"
import LandingPageView from "@/components/landing-page"
import { MATCHA_PAGE } from "@/lib/data/landing/matcha"
import { buildLandingHead } from "@/lib/utils/landing-head"

const SUPPORTED_COUNTRY_CODES = new Set(["us"])

export const Route = createFileRoute("/$countryCode/matcha")({
  loader: ({ params }) => {
    if (!SUPPORTED_COUNTRY_CODES.has(params.countryCode.toLowerCase())) {
      throw notFound()
    }
    return { countryCode: params.countryCode }
  },
  head: () => buildLandingHead(MATCHA_PAGE),
  component: () => <LandingPageView page={MATCHA_PAGE} />,
})
